<template>
  <BModal
    id="user-password-modal"
    ref="user-password-modal"
    hide-footer="hide-footer"
    modal-class="modal-width-320"
  >
    <template slot="modal-header">
      <h5
        class="modal-title"
        id="user-password-modal-label"
      >
        Trocar a senha do usuário<b> {{ user.name }}</b>
      </h5>
      <button
        class="close"
        type="button"
        @click="close()"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </template>
    <template slot="default">
      <form @submit.prevent="update">
        <div
          class="form-group"
          :class="{ 'has-error': passwordForm.errors.has('current_password') }"
        >
          <label for="current_password">Senha atual</label>
          <input
            class="form-control"
            id="current_password"
            type="password"
            name="current_password"
            v-model="passwordForm.current_password"
            required=""
          ><span
            class="form-text"
            v-show="passwordForm.errors.has('current_password')"
          >{{ passwordForm.errors.get('current_password') }}</span>
        </div>
        <div
          class="form-group"
          :class="{ 'has-error': passwordForm.errors.has('password') }"
        >
          <label for="password">Nova senha</label>
          <input
            class="form-control"
            id="password"
            type="password"
            name="password"
            v-model="passwordForm.password"
            required=""
          ><span
            class="form-text"
            v-show="passwordForm.errors.has('password')"
          >{{ passwordForm.errors.get('password') }}</span>
        </div>
        <div
          class="form-group"
          :class="{ 'has-error': passwordForm.errors.has('password_confirmation') }"
        >
          <label for="password_confirmation">Confirme a nova senha</label>
          <input
            class="form-control"
            id="password_confirmation"
            type="password"
            name="password_confirmation"
            v-model="passwordForm.password_confirmation"
            required=""
          ><span
            class="form-text"
            v-show="passwordForm.errors.has('password_confirmation')"
          >{{ passwordForm.errors.get('password_confirmation') }}</span>
        </div>
        <div class="modal-footer default-modal-footer">
          <button
            class="btn"
            type="button"
            @click="close()"
          >
            Cancelar
          </button>
          <button
            class="btn btn-box-success"
            type="submit"
          >
            Confirmar
          </button>
        </div>
      </form>
    </template>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

function addPasswordForm () {
  return new BulldeskForm({
    current_password: '',
    password: '',
    password_confirmation: '',
  });
}

export default {
  components: {
    BModal,
  },

  data () {
    return {
      user: {
        id: '',
        name: '',
      },
      passwordForm: addPasswordForm(),
    };
  },

  mounted () {
    Bus.$on('userChangePassword', (data) => {
      const { id, user } = JSON.parse(data);

      this.user.id = id;
      this.user.name = user;
      this.open();
    });
  },

  methods: {
    update () {
      Http.put(`/user/${this.user.id}`, this.passwordForm)
        .then((response) => {
          Alert.success(this.__('Senha alterada!'));
          this.close();
        });
    },

    open () {
      this.$refs['user-password-modal'].show();
    },

    close () {
      this.$refs['user-password-modal'].hide();
      this.passwordForm = addPasswordForm();
    },
  },
};
</script>
